import controller from './query-rule.controller';
import template from './query-rule.html';
import './query-rule.scss';

export default {
	controller,
	template,
	bindings: {
		index:   '<index',
		group:   '<group',
		options: '<?options',
		rule:    '=ngModel',
	},
	require:  {
		builder:     '^^?queryBuilder',
		children:    '^^?queryBuilderChildren',
		editor:      '^^?queryEditor',
		ngModelCtrl: '?ngModel',
		parent:      '^^?queryRule',
	},
};
